import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	header: {
		id: 'error-pages.container-view-not-found-error-page.header',
		defaultMessage: "We can't find the page you're looking for",
		description: 'Header that tells user we could not find a page with such url',
	},
	goToDefaultView: {
		id: 'error-pages.container-view-not-found-error-page.goToDefaultView',
		defaultMessage: 'Go to the default view',
		description:
			'Button sends the user to the default view for the container (project, board or else)',
	},
});
